module.exports = __webpack_public_path__ + "img/5.59f0e89.svg";